import React, { useContext, useState, useEffect } from 'react';
import Header from '../Common/Header';
import Sidebar from '../Common/Sidebar';
import Footer from '../Common/Footer';
import { GMCContext } from '../../GMCContext';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Pagination from '../Common/Pagination';
import Copy from '../Common/Copy';
import toast from 'react-hot-toast';

export default function AdminDiposit() {
    const { togel, setTogel, isSidebarEnabled, setIsSidebarEnabled, formatDateTime } = useContext(GMCContext);
    const { formatAddress } = useContext(GMCContext);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [pages, setPages] = useState(1);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [isDarkMode, setIsDarkMode] = useState(false);
    const [newaddressFilter, setNewaddressFilter] = useState(""); // State for amount
    const [selectedUser, setSelectedUser] = useState(null);
    const [editData, setEditData] = useState({ username: "", toname: "", ref_address: "" });
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [authNumber, setAuthNumber] = useState('');
    const [msg, setMsg] = useState('');
    const [showMsg, setShowMsg] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [error, setError] = useState(false);
    const handleEditClick = (user) => {
        setSelectedUser(user);
        setEditData({
            ref_address: user.ref_address || "",
            username: user.username || "",
            toname: user.toname || ""
        });
    }
    const closeModal = () => {
        setSelectedUser(null);
    }

    const updateData = async () => {
        try {
            const ress = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "admin",
                submethod: "admindeposit",
                key: process.env.REACT_APP_KEY,
                search: search,
                page: currentPage,
                pageSize: pageSize,
                username: editData.username,  // Sending username
                deposit: newaddressFilter      // Sending amount from input field
            });

            if (ress.data.msg) {
                toast.success("Deposit successful!");
            } else {
                toast.error(ress.data.error || "An error occurred!");
            }

            console.log('Sent data:', { username: editData.username, deposit: newaddressFilter });
            setSelectedUser(null);
            getData(); // Refresh data after update
        } catch (error) {
            console.log("Error:", error);

            // Check if the error response has a message
            const errorMessage = error.response?.data?.message || "Something went wrong!";
            toast.error(errorMessage);
        }
    };


    const insertCode = async () => {
        try {
            const state = JSON.parse(localStorage.getItem('mark#0143'));
            // console.log('state',state);

            const response = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "verify2",
                submethod: "insert",
                key: process.env.REACT_APP_KEY,
                authNumber,
                username: state.username,
                _id: state._id,
            });
            console.log('response', response)
            const { resCode, error, token } = response.data;

            if (resCode === 200 && token) {
                setMsg("Verified successfully");
                setShowMsg(true);
                setIsAuthenticated(true);
            } else {
                setErrorMessage(error || "Verification failed. Please try again.");
                setError(true);
            }
        } catch (err) {
            console.error("Error inserting data:", err);
            setErrorMessage("Network error. Please try again later.");
            setError(true);
        }
    };


    // Filter States
    const [addressFilter, setAddressFilter] = useState("");
    const [refAddressFilter, setRefAddressFilter] = useState("");
    const [statusFilter, setStatusFilter] = useState("");  // Empty by default to fetch all
    const [joiningDateFilter, setJoiningDateFilter] = useState("");


    // Fetch data function
    const getData = async () => {

        try {
            setLoading(true);
            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "user",
                submethod: "get",
                key: process.env.REACT_APP_KEY,
                search: search,
                page: currentPage,
                pageSize: pageSize,
                address: addressFilter,
                refAddress: refAddressFilter,
                status: statusFilter !== "" ? (statusFilter === "active" ? true : false) : undefined, // Filter based on status
                joiningDate: joiningDateFilter,
            });
            console.log('serarch', search)
            setLoading(false);
            if (res.data.error) return;
            console.log('res.data.data', res.data.data)

            setData(res.data.data);
            setPages(Math.ceil(res.data.total / pageSize));
            // if (res.data.data.length > 0) {
            //   const firstUser = res.data.data[0].username; // Get first username
            // updateData(firstUser); // Pass username to updateData
            // }
        } catch (err) {
            console.log("error : ", err);
            setLoading(false);
        }
    };

    useEffect(() => {
    getData();
  }, [pageSize, currentPage, search]);
  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1); // Reset to page 1 if currentPage is out of range
    }
  }, [pages]);

    return (
        <>
            <div id="layout-wrapper">
                <Header />
                <Sidebar />
                <div className="vertical-overlay" onClick={() => setIsSidebarEnabled((prev) => !prev)} />
                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid" >
                            {!isAuthenticated ? (
                                // Authentication Form
                                <div className="col-md-6 mx-auto">
                                    <div className="card shadow-lg rounded p-4">
                                        <div className="text-center mb-4">
                                            <h4 className="text-primary">Verify Your Authentication Key!</h4>
                                        </div>
                                        <form autoComplete="off">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    className="form-control form-control-lg bg-light border-light text-center"
                                                    placeholder="Enter Authentication Key"
                                                    onChange={(e) => setAuthNumber(e.target.value)}
                                                />
                                            </div>
                                        </form>
                                        {error && errorMessage && (
                                            <div className="alert alert-danger mt-3" role="alert">
                                                {errorMessage}
                                            </div>
                                        )}
                                        {showMsg && msg && (
                                            <div className="alert alert-success mt-3" role="alert">
                                                {msg}
                                            </div>
                                        )}
                                        <div className="mt-3">
                                            <button
                                                type="button"
                                                className="btn btn-success w-100"
                                                onClick={insertCode}
                                            >
                                                Confirm
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            ) : (
                                <>
                                    {/* Page Title Section */}
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
                                                <ol className="breadcrumb m-0">
                                                    <li className="breadcrumb-item"><a href="javascript: void(0);">Tables</a></li>
                                                    <li className="breadcrumb-item active">Member Report</li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Member Report Table Section */}
                                    <div className="row">
                                        <div className="col-lg-12" onClick={() => setIsDarkMode((prev) => !prev)}>
                                            <div className="card">
                                                <div className="card-header">
                                                    <h4 className="card-title mb-0">Member Report</h4>
                                                </div>
                                                <div className="card-body">
                                                    <div className="listjs-table" id="customerList">
                                                        {/* Table Action Buttons */}
                                                        <div className="row g-4 mb-3">
                                                            <div className="col-sm-auto">
                                                            </div>
                                                            <div className="col-sm">
                                                                <div className="d-flex justify-content-sm-end">
                                                                    <div className="search-box ms-2">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control search"
                                                                            placeholder="Search..."
                                                                            onChange={(e) => setSearch(e.target.value)}
                                                                        />
                                                                        <i className="ri-search-line search-icon" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Table */}
                                                        <div className="table-responsive table-card mt-3 mb-1">
                                                            <table className="table align-middle table-nowrap" id="customerTable">
                                                                <thead className="table-light">
                                                                    <tr>

                                                                        <th style={{ textAlign: "center", verticalAlign: "middle" }} class="gridjs-th">#</th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle" }} class="gridjs-th">From User</th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle" }} class="gridjs-th">To User</th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle" }} class="gridjs-th">Total Staking</th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle" }} class="gridjs-th">Level Reward</th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle" }} class="gridjs-th">Pool Reward</th>
                                                                        {/* <th style={{ textAlign: "center", verticalAlign: "middle" }        } class="gridjs-th">Team Business</th> */}
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle" }} class="gridjs-th">Weekly Reward</th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle" }} class="gridjs-th">Total Deposit</th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle" }} class="gridjs-th">
                                                                            Re-Stake Status

                                                                        </th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle" }} class="gridjs-th">
                                                                            Status

                                                                        </th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle" }} class="gridjs-th">
                                                                            Joining Date
                                                                        </th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle" }} class="gridjs-th">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {data.length > 0 ? (
                                                                        data.map((ele, i) => {
                                                                            const index = currentPage * pageSize - pageSize + (i + 1);
                                                                            return (
                                                                                <tr key={i}>

                                                                                    <td class="gridjs-td" style={{ textAlign: "center" }}>{index} </td>
                                                                                    {/*  Address */}
                                                                                    <td className="gridjs-td" style={{ textAlign: "start" }}>
                                                                                        <div>
                                                                                            <a
                                                                                                target="_blank"
                                                                                                className="text-primary"
                                                                                                href={`${process.env.REACT_APP_EXPLORER}/address/${ele.username}`}
                                                                                                rel="noreferrer"
                                                                                            >
                                                                                                <span className="name-title">Address:</span> {ele.username}
                                                                                            </a>
                                                                                            <Copy data={ele.username} /> {/* Use the Copy component */}
                                                                                        </div>
                                                                                        <div className="username-name">
                                                                                            <span className="name-title">Name:</span> {ele.fromname || "-"}
                                                                                            <Copy data={ele.fromname} />
                                                                                        </div>
                                                                                    </td>
                                                                                    {/* Ref. Address */}
                                                                                    <td className="gridjs-td" style={{ textAlign: "start" }}>
                                                                                        <div>
                                                                                            <a
                                                                                                target="_blank"
                                                                                                className="text-primary"
                                                                                                href={`${process.env.REACT_APP_EXPLORER}/address/${ele.ref_address}`}
                                                                                                rel="noreferrer"
                                                                                            >
                                                                                                <span className="name-title">Address:</span>{ele.ref_address}
                                                                                            </a>
                                                                                            <Copy data={ele.ref_address} /> {/* Use the Copy component */}
                                                                                        </div>
                                                                                        <div className="ref-name">
                                                                                            <span className="name-title">Name:</span> {ele.toname || "-"}
                                                                                            <Copy data={ele.toname} />
                                                                                        </div>
                                                                                    </td>
                                                                                    <td class="gridjs-td" style={{ textAlign: "center" }}>${ele.totalstake || "0"}</td>
                                                                                    <td class="gridjs-td" style={{ textAlign: "center" }}>${ele.level_rew || "0"}</td>
                                                                                    <td class="gridjs-td" style={{ textAlign: "center" }}>${ele.pool_rew || "0"}</td>
                                                                                    {/* <td class="gridjs-td"  style={{ textAlign: "center" }}>{ele.teamBusiness || "0"}</td> */}
                                                                                    <td class="gridjs-td" style={{ textAlign: "center" }}>${parseFloat(ele.week_rew).toFixed(2) || "0"}</td>
                                                                                    <td class="gridjs-td" style={{ textAlign: "center" }}>${ele.totalDeposit || "0"}</td>
                                                                                    <td className="gridjs-td" style={{ textAlign: "center" }}>
                                                                                        <span className={`badge ${ele.restake ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'} text-uppercase`}>
                                                                                            {ele.restake ? "Active" : "Deactive"}
                                                                                        </span>
                                                                                    </td>
                                                                                    <td className="gridjs-td" style={{ textAlign: "center" }}>
                                                                                        <span className={`badge ${ele.status ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'} text-uppercase`}>
                                                                                            {ele.status ? "Active" : "Deactive"}
                                                                                        </span>
                                                                                    </td>

                                                                                    <td className="gridjs-td" style={{ textAlign: "center" }}>{formatDateTime(ele.date)}</td>
                                                                                    <td className="gridjs-td" style={{ textAlign: "center" }}>
                                                                                        <div className="d-flex gap-2 " style={{ textAlign: "center" }}>
                                                                                            {/* View Button */}
                                                                                            <Link
                                                                                                to={`/userreport/${ele.username}`}
                                                                                                className="btn btn-primary btn-sm"
                                                                                                title="View User Report"
                                                                                            >
                                                                                                <i className="ri-eye-line"></i>
                                                                                            </Link>
                                                                                            {/* Edit Button - Only if totalstake is 0 */}
                                                                                            {/* {parseFloat(ele.totalstake) === 0 && ele.team === 0 && ( */}
                                                                                            <button
                                                                                                className="btn btn-sm btn-success edit-item-btn"
                                                                                                title="Edit User"
                                                                                                onClick={() => handleEditClick(ele)} // Open modal
                                                                                            >
                                                                                                <i className="ri-ball-pen-line"></i>
                                                                                            </button>
                                                                                            {/* )} */}




                                                                                        </div>

                                                                                    </td>

                                                                                </tr>
                                                                            );
                                                                        })
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan="11" className="text-center">
                                                                                No data available
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                            {/* Modal */}
                                                            {selectedUser && (
                                                                <div className="custom-modal-overlay">
                                                                    <div className="custom-modal">
                                                                        <div className="modal-header">
                                                                            <h5 className="modal-title">Edit User</h5>
                                                                            <button type="button" className="close-button" onClick={() => setSelectedUser(null)}>&times;</button>
                                                                        </div>
                                                                        <div className="modal-body">
                                                                            <p><strong>User Address:</strong></p>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                value={editData.username}
                                                                                disabled // Non-editable
                                                                            />

                                                                            <p><strong>Amount:</strong></p>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                value={newaddressFilter}
                                                                                onChange={(e) => setNewaddressFilter(e.target.value)}
                                                                            />
                                                                        </div>
                                                                        <div className="modal-footer">
                                                                            <button type="button" className="btn btn-secondary" onClick={() => setSelectedUser(null)}>Close</button>
                                                                            <button type="button" className="btn btn-primary" onClick={updateData}>Save Changes</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* CSS for Custom Modal */}
                                                            <style>
                                                                {`
          .custom-modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1050;
          }
          
          .custom-modal {
            background: white;
            padding: 20px;
            border-radius: 8px;
            width: 400px;
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
            position: relative;
          }

          .modal-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #ddd;
            padding-bottom: 10px;
          }

          .modal-body {
            padding: 15px 0;
          }

          .modal-footer {
            display: flex;
            justify-content: space-between;
            padding-top: 10px;
            border-top: 1px solid #ddd;
          }

          .close-button {
            background: none;
            border: none;
            font-size: 20px;
            cursor: pointer;
          }
        `}
                                                            </style>

                                                        </div>

                                                        {/* Pagination */}
                                                        <Pagination
                                                            currentPage={currentPage}
                                                            setCurrentPage={setCurrentPage}
                                                            pageSize={pageSize}
                                                            setPageSize={setPageSize}
                                                            pages={pages}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}